import React from 'react'
import HotelsWorker from './hotels'
import { Link, withRouter } from 'react-router-dom'
import iconEdit from '../../../assets/icons/edit-black.svg'
import iconDelete from '../../../assets/icons/delete-black.svg'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import NumberFormat from 'react-number-format'

class Hotels extends React.Component {

    constructor() {
        super()
        this.hotelsWorker = HotelsWorker(this)
        this.state = this.hotelsWorker.getDefaultState()
    }

    componentDidMount() {
        this.hotelsWorker.loadHotels()
    }

    onDelete = id => this.hotelsWorker.deleteHotel(id)

    getStatusLabel = status => {
        switch (Number(status)) {
            case 0:
                return "Draft"
            case 1:
                return "Published"
            case 2:
                return "Archived"
            default:
                return status
        }
    }

    getTypeLabel = type => {
        switch (Number(type)) {
            case 0:
                return "Hotel"
            case 1:
                return "Apartment"
            default:
                return type
        }
    }

    render() {
        return (
            <div className="hotels">
                {
                    this.state.loading && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/hotels/create">New Hotel</Link>
                    <div className="header">
                        <h4>Hotels</h4>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Location</th>
                                <th>Stars</th>
                                <th>Price</th>
                                <th>Features</th>
                                <th>Status</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.hotels.map((hotel, key) => {
                                    const updatedAt = hotel.updatedAt || hotel.updated
                                    return (
                                        <tr key={key}>
                                            <td>{hotel.name}</td>
                                            <td>{this.getTypeLabel(hotel.type)}</td>
                                            <td>{hotel.city}, {hotel.country}</td>
                                            <td>{hotel.stars}</td>
                                            <td>
                                                <NumberFormat value={hotel.price} displayType="text" thousandSeparator={true} prefix="₦" />
                                            </td>
                                            <td>{hotel.features || "-"}</td>
                                            <td>{this.getStatusLabel(hotel.status)}</td>
                                            <td>{updatedAt ? new Date(updatedAt).toLocaleString() : "-"}</td>
                                            <td>
                                                <div className="actions">
                                                    <img alt="" src={iconEdit} onClick={() => this.props.history.push('/content/hotels/edit/' + hotel.id)} />
                                                    {
                                                        this.state.deletingId === hotel.id ? <Loading /> : <img alt="" src={iconDelete} onClick={() => this.onDelete(hotel.id)} />
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default withRouter(Hotels)
